module.exports = __webpack_public_path__ + "static/media/technologies.d2b2ab09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/technologies.svg
// module id = 261
// module chunks = 0